<a class="text-blue-600 underline" [routerLink]="[base(), id()]">{{ label() || id() }}</a>
